import { LoadingSpinner } from "components";
import { LoginForm } from "components/login-form/login-form";
import { useLogin } from "hooks";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { setGuid } from "redux/slices";
import { useAppDispatch } from "redux/store";

export const NoGuidPage = () => {
  const dispatch = useAppDispatch();
  const [submittedValue, setSubmittedValue] = useState("");
  const { login, apiStatus, session } = useLogin();

  const navigation = useNavigate();

  const handleSuccessLogin = useCallback(() => {
    dispatch(setGuid(submittedValue));
    navigation(`/${submittedValue}`);
  }, [dispatch, navigation, submittedValue]);

  useEffect(() => {
    if (apiStatus === "fulfilled" && session) {
      handleSuccessLogin();
    }
  }, [apiStatus, handleSuccessLogin, session]);

  const handleSubmitAction = (guid: string) => {
    setSubmittedValue(guid);
    login(guid);
  };

  if (apiStatus === "pending") {
    return <LoadingSpinner />;
  }
  return (
    <div className="h-100 m-auto">
      <LoginForm
        title="Accedi all’area di transito:"
        inputPlaceholder="Account"
        inputType="text"
        initialInputValue={submittedValue}
        submitAction={handleSubmitAction}
      />
    </div>
  );
};
